module.exports = __webpack_public_path__ + "static/media/logo.1b2a8c63.png";